import { FormControl, RadioGroup } from "@mui/material";
import { styled } from "@mui/system";

export const StyledInlineRadioGroupForm = styled(FormControl)(({ theme }) => ({
  width: "100%"
}));

export const StyledInlineRadioGroup = styled(RadioGroup)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "space-between",
  width: "100%",
  flexWrap: "nowrap",
  rowGap: "16px",
  "& > .box-group-grid": {
    marginLeft: "40px"
  },
  "&.disabledLabel": {
    color: "#86868b"
  },
  label: {
    border: "1px solid var(--Color-Border-Default-On-Light, #CCC)",
    "&.selectedRadioButton": {
      border: "1px solid var(--Color-Text-Primary-On-Light, #1F1F1F)"
    }
  },
  "& .inlineFormRadioWrapper": {
    display: "flex",
    flexShrink: 1,
    flexWrap: "wrap",
    columnGap: "16px",
    [theme.breakpoints.down("sm")]: {
      rowGap: "16px"
    }
  }
}));

export const StyledLabel = styled("span")(({ theme }) => ({
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 500,
  color: "var(--Color-Text-Primary-On-Light, #1F1F1F)"
}));
